<template>
  <div class="page" @mousemove="onMove" @mouseleave="mx=0;my=0">
    <!-- Ambient background -->
    <div class="amb a1"></div><div class="amb a2"></div><div class="amb a3"></div>
    <div class="dots"></div>
    <div class="ring r1"></div><div class="ring r2"></div>
    <div class="bg-grid"></div>

    <!-- Navigation -->
    <div class="nav-bar" :style="[navElastic, navTiltStyle]" @mousemove="navTilt" @mouseleave="navTiltReset">
      <el-image class="nav-logo" @click="backHome" :src="logo" />
      <a class="nav-f" href="https://www.osredm.com/">首页</a>
      <a class="nav-s" href="https://www.osredm.com/explore/all">开源项目</a>
      <a class="nav-s" href="https://www.osredm.com/task">创客空间</a>
      <a class="nav-s" href="https://fc.osredm.com/competitions">开放竞赛</a>
      <a class="nav-s" href="https://fc.osredm.com/forums">论坛交流</a>
      <router-link to="/" class="nav-back">← 返回工具集</router-link>
    </div>

    <div class="hero">
      <div class="hero-visual" :style="tilt(10)">
        <div class="hv-glow"></div>
        <div class="hv-ring"></div>
        <svg viewBox="0 0 160 160" fill="none"><defs><linearGradient id="h1" x1="0" y1="0" x2="160" y2="160"><stop stop-color="#e74c3c"/><stop offset="1" stop-color="#f59e0b"/></linearGradient></defs><rect x="12" y="12" width="136" height="136" rx="36" fill="rgba(231,76,60,0.03)" stroke="url(#h1)" stroke-width="2"/><path d="M44 56h72v8H44zm0 20h72v8H44zm0 20h48v8H44z" fill="url(#h1)" opacity="0.5"/><circle cx="120" cy="106" r="16" stroke="url(#h1)" stroke-width="2.5" fill="rgba(231,76,60,0.06)"/><path d="M114 106l4 4 8-8" stroke="url(#h1)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M74 20l-6 16h12z" fill="url(#h1)" opacity="0.4"/><path d="M94 20l-6 16h12z" fill="url(#h1)" opacity="0.6"/></svg>
      </div>
      <span class="chip">国产化迁移与兼容 · 自主可控</span>
      <h1>国产化迁移适配工具</h1>
      <p>一站式国产化迁移适配与兼容运行平台，支持非国产化软件向国产平台的平滑迁移与高效运行</p>
      <div class="kpi">
        <div class="kp" :style="tilt(5)"><em>6<span>+</span></em><label>主流语言支持</label></div>
        <div class="kp" :style="tilt(5)"><em>2<span>大</span></em><label>迁移兼容模式</label></div>
        <div class="kp" :style="tilt(5)"><em>多<span>架构</span></em><label>处理器平台</label></div>
        <div class="kp" :style="tilt(5)"><em>全<span>场景</span></em><label>行业软件覆盖</label></div>
      </div>
    </div>

    <div class="main">
      <div class="sec-head"><span class="sh-tag">About</span><h2>平台简介</h2></div>
      <div class="intro-card" :style="tilt(3)">
        <div class="ic-line"></div>
        <p>本工具面向国产化替代与自主可控需求，覆盖 <strong>C/C++、Fortran、Python、Java、JavaScript</strong> 等主流语言，支持 <strong>飞腾、海光</strong> 等多种国产处理器，提供从<strong>开发调试、迁移部署</strong>到<strong>兼容运行</strong>的全链路工具链，助力软件系统在国产基础软硬件平台上稳定高效运行。</p>
      </div>

      <div class="sec-head"><span class="sh-tag">Module 1</span><h2>国产化迁移适配</h2></div>
      <div class="fgrid">
        <div class="fcard" v-for="(f,i) in features1" :key="i" :style="tilt(6)">
          <div class="fc-top"></div>
          <div class="fc-body">
            <div class="fc-icon" v-html="f.icon"></div>
            <h4>{{ f.title }}</h4>
            <p>{{ f.desc }}</p>
          </div>
        </div>
      </div>

      <div class="sec-head"><span class="sh-tag">Module 2</span><h2>国产化兼容运行</h2></div>
      <div class="fgrid">
        <div class="fcard" v-for="(f,i) in features2" :key="i" :style="tilt(6)">
          <div class="fc-top"></div>
          <div class="fc-body">
            <div class="fc-icon" v-html="f.icon"></div>
            <h4>{{ f.title }}</h4>
            <p>{{ f.desc }}</p>
          </div>
        </div>
      </div>

      <div class="sec-head"><span class="sh-tag">Scenarios</span><h2>适用场景</h2></div>
      <div class="fgrid">
        <div class="scard" v-for="(s,i) in scenes" :key="i" :style="tilt(4)">
          <span class="sn">{{ i+1 }}</span>
          <div><h5>{{ s.title }}</h5><p>{{ s.desc }}</p></div>
        </div>
      </div>

      <div class="apply">
        <div class="ag a1"></div><div class="ag a2"></div><div class="ag a3"></div>
        <h2>申请使用</h2>
        <p>本工具需审核开通，填写信息后 1-2 个工作日内联系您</p>
        <el-form :model="form" label-position="top" @submit.native.prevent="submitForm">
          <div class="form-row">
            <el-form-item label="姓名"><el-input v-model="form.name" placeholder="姓名" /></el-form-item>
            <el-form-item label="单位/公司"><el-input v-model="form.company" placeholder="单位或公司" /></el-form-item>
          </div>
          <div class="form-row">
            <el-form-item label="手机号"><el-input v-model="form.phone" placeholder="手机号码" /></el-form-item>
            <el-form-item label="电子邮箱"><el-input v-model="form.email" placeholder="邮箱地址" /></el-form-item>
          </div>
          <el-form-item label="用途说明">
            <el-input v-model="form.purpose" type="textarea" :rows="2" placeholder="请简述使用目的与场景" />
          </el-form-item>
          <div class="btns">
            <el-button type="primary" native-type="submit" :loading="submitting" class="btn-p">{{ submitting?'提交中...':'提交申请' }}</el-button>
            <span class="hint">* 本工具仅支持线下交付使用，提交申请后工作人员将与您联系</span>
          </div>
        </el-form>
      </div>
    </div>

    <footer class="foot">
      <div class="foot-glow"></div>
      <div class="foot-top">
        <div class="foot-brand">
          <img class="foot-logo" :src="logoWhite" alt="OSREDM" />
          <p class="foot-desc">面向开源生态的一站式在线工具平台</p>
        </div>
        <div class="foot-links">
          <h5>导航</h5>
          <router-link to="/">返回工具集</router-link>
          <a href="https://www.osredm.com/explore/all">开源项目</a>
          <a href="https://www.osredm.com/task">创客空间</a>
          <a href="https://fc.osredm.com/competitions">开放竞赛</a>
        </div>
        <div class="foot-links">
          <h5>工具</h5>
          <router-link to="/cssTools">CSS 格式化</router-link>
          <router-link to="/jsonTools">JSON 格式化</router-link>
          <router-link to="/xmlTools">XML 格式化</router-link>
          <router-link to="/uuidTools">UUID 生成器</router-link>
          <router-link to="/encryptionTool">加解密工具</router-link>
        </div>
        <div class="foot-links">
          <h5>更多</h5>
          <router-link to="/componentTrustTool">组件可信管理</router-link>
          <router-link to="/componentDepsTool">依赖分析裁剪</router-link>
          <router-link to="/domesticMigrationTool">国产化迁移适配</router-link>
          <router-link to="/Activity">活动报名</router-link>
        </div>
      </div>
      <div class="foot-bar">
        <span>© 2026 OSREDM.COM</span>
        <a href="https://www.osredm.com/">平台首页</a>
        <a href="https://fc.osredm.com/forums">论坛交流</a>
        <a href="https://fc.osredm.com/competitions">开放竞赛</a>
        <router-link to="/admin">管理</router-link>
      </div>
    </footer>
  </div>
</template>

<script>
import { regInsert2 } from "@/utils/http/interface";
export default {
  name:"DomesticMigrationTool",
  data(){return{ submitting:false, form:{name:'',company:'',phone:'',email:'',purpose:''},
    mx:0, my:0, logo:require("@/assets/logo/osredm-logo-black-new.png"), logoWhite:require("@/assets/logo/osredmLogo-white.svg"),
    navElastic:{}, lastScrollY:0, scrollSpeed:0, rafId:0, navTiltStyle:{},
    features1:[
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>',title:'多语言集成开发环境',desc:'支持 C/C++、Fortran、Python、Java、JavaScript 在统一界面中开发、调试、编译与运行，适配飞腾、海光等国产处理器'},
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',title:'调试增强功能',desc:'针对国产软硬件特性的反向调试、堆栈历史调试、内存泄露检测、死锁检测及 coredump 文件分析'},
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',title:'国产化迁移部署',desc:'软件符号分析与依赖分析，VS 项目工程自动迁移、编码转换、代码分析，图形化安装包制作与一键部署'},
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',title:'跨平台安装包工具',desc:'支持软件在不同国产平台下制作图形化安装包，实现一键部署与版本管理'},
    ],
    features2:[
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/></svg>',title:'非虚拟化兼容运行',desc:'利用跨系统 API 转换与异构指令转译技术，在 ARM 架构国产平台上直接运行 x86 Windows/Linux 软件及大型 AI 训练推理框架'},
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="20" height="20" rx="2"/><circle cx="12" cy="12" r="4"/><line x1="4" y1="4" x2="8" y2="8"/><line x1="20" y1="4" x2="16" y2="8"/><line x1="4" y1="20" x2="8" y2="16"/><line x1="20" y1="20" x2="16" y2="16"/></svg>',title:'虚拟化兼容运行',desc:'混合虚拟化、指令转换引擎、图形转换引擎与 GPU 虚拟化技术，构建稳定可靠的国产平台虚拟机环境'},
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>',title:'行业软件兼容支持',desc:'支持 Office、CAD/CAE、ERP、EDA、三维图形应用等 x86/Windows 版本行业软件在国产平台上高效稳定运行'},
      {icon:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>',title:'多层兼容架构',desc:'同时支持 x86→ARM、x86→x86 等多种迁移路径，覆盖不同国产平台与架构组合的兼容运行需求'},
    ],
    scenes:[
      {title:'存量软件国产化迁移',desc:'将现有 Windows/Linux 平台软件系统平滑迁移至国产基础软硬件平台'},
      {title:'大型专业软件兼容运行',desc:'在国产平台上直接运行 CAD/CAE/ERP/EDA 等大型行业软件及专业科学计算工具'},
      {title:'AI 训练推理环境适配',desc:'将 x86 Linux 版本的 AI 训练推理软件迁移至 ARM 架构国产平台高效运行'},
      {title:'关键业务系统平滑过渡',desc:'为关键业务系统提供虚拟化与兼容运行方案，确保国产化替代过程业务不中断'},
    ]
  }},
  methods:{
    tilt(r){ var rx=-this.my*r; var ry=this.mx*r; return {transform:'perspective(800px) rotateX('+rx+'deg) rotateY('+ry+'deg)'}; },
    onMove(e){ this.mx=(e.clientX/window.innerWidth-0.5); this.my=(e.clientY/window.innerHeight-0.5); },
    backHome(){ this.$router.push('/'); },
    navTilt(e){var r=this.$el.querySelector('.nav-bar');var x=(e.clientX-r.getBoundingClientRect().left)/r.offsetWidth-0.5;var y=(e.clientY-r.getBoundingClientRect().top)/r.offsetHeight-0.5;this.navTiltStyle={transform:'translateX(-50%) perspective(600px) rotateX('+(-y*8)+'deg) rotateY('+(x*8)+'deg)',transition:'transform 0.15s cubic-bezier(0.16,0.1,0.1,0.99)'};},navTiltReset(){this.navTiltStyle={transform:'translateX(-50%) perspective(600px) rotateX(0) rotateY(0)',transition:'transform 0.5s cubic-bezier(0.18,1.5,0.4,1)'};},
    async submitForm(){if(!this.form.name||!this.form.phone||!this.form.email){this.$message.warning('请填写姓名、手机号和邮箱');return}this.submitting=true;try{await regInsert2({...this.form, tool:'国产化迁移适配工具'});this.$message.success('申请已提交，将在 1-2 个工作日内联系您');this.form={name:'',company:'',phone:'',email:'',purpose:''}}catch(e){this.$message.error('提交失败，请稍后重试')}this.submitting=false},
    onScroll(){var s=window.scrollY;var d=s-this.lastScrollY;var absD=Math.abs(d);this.lastScrollY=s;
      var sy=1+Math.min(absD*0.002, 0.1);var ty=d>0?Math.min(absD*0.2, 12):Math.max(d*0.2, -12);
      this.navElastic={transform:'translateX(-50%) scaleY('+sy+') translateY('+ty+'px)',transition:'none'};
      cancelAnimationFrame(this.rafId);
      this.rafId=requestAnimationFrame(this.springBack);
    },
    springBack(){
      this.navElastic={transform:'translateX(-50%) scaleY(1) translateY(0px)',transition:'transform 0.6s cubic-bezier(0.18,1.9,0.4,1)'};
    },
  },
  mounted(){window.addEventListener('scroll',this.onScroll,{passive:true});},
  beforeDestroy(){window.removeEventListener('scroll',this.onScroll);cancelAnimationFrame(this.rafId);},
}
</script>

<style scoped>
.page { min-height:100vh; color:#1a1744; position:relative; overflow-x:hidden; background:#f8f7fd; padding-top:92px; box-sizing:border-box; }
.page * { box-sizing:border-box; }

/* ===== NAV (same as homepage) ===== */
.nav-bar{ position:fixed; top:12px; left:50%; transform:translateX(-50%); z-index:100; width:min(100% - 24px, 1400px); height:64px; display:flex; text-align:center; align-items:center; font-weight:600; padding:0 28px; border-radius:24px; will-change:transform;
  background:rgba(255,255,255,0.45);
  backdrop-filter:blur(14px) saturate(200%) brightness(1.08) contrast(1.04);
  -webkit-backdrop-filter:blur(14px) saturate(200%) brightness(1.08) contrast(1.04);
  border:1px solid rgba(255,255,255,0.5);
  box-shadow:
    0 0.5px 0 rgba(255,255,255,0.6) inset,
    0 1px 2px rgba(255,255,255,0.4),
    0 4px 14px rgba(0,0,0,0.03),
    0 8px 28px rgba(231,76,60,0.05),
    0 0 0 1px rgba(231,76,60,0.02);
  transition:box-shadow 0.3s ease, border-color 0.3s ease; }
.nav-bar::before{ content:''; position:absolute; inset:-12px; border-radius:36px; pointer-events:auto; z-index:-1; }
.nav-bar:hover{ border-color:rgba(231,76,60,0.15); box-shadow:0 0.5px 0 rgba(255,255,255,0.7) inset, 0 1px 2px rgba(255,255,255,0.5), 0 4px 14px rgba(0,0,0,0.04), 0 8px 28px rgba(231,76,60,0.12), 0 0 0 1px rgba(231,76,60,0.08), 0 0 60px rgba(231,76,60,0.1); }
.nav-logo{ margin-left:20px; margin-right:44px; width:auto; height:34px; cursor:pointer; }
.nav-f{ margin-left:20px; color:var(--text-nav); text-decoration:none; }
.nav-f:hover{ color:var(--accent-soft); }
.nav-s{ margin-left:56px; color:var(--text-nav); text-decoration:none; }
.nav-s:hover{ color:var(--accent-soft); }
.nav-back{ margin-left:auto; color:var(--accent-soft); text-decoration:none; font-size:13px; font-weight:600; padding:8px 18px; border-radius:20px; background:var(--btn-glass-bg); border:1px solid var(--btn-glass-border); transition:all 0.3s; white-space:nowrap; }
.nav-back:hover{ background:var(--bg-card-hover); }

/* ===== BG GRID ===== */
.bg-grid { position:fixed; inset:0; z-index:1; pointer-events:none; opacity:0.04;
  background-image:linear-gradient(rgba(231,76,60,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(231,76,60,0.5) 1px, transparent 1px);
  background-size:40px 40px;
  mask-image:radial-gradient(ellipse 80% 60% at 50% 30%, black 30%, transparent 70%); -webkit-mask-image:radial-gradient(ellipse 80% 60% at 50% 30%, black 30%, transparent 70%); }

/* Ambient */
.amb { position:fixed; border-radius:50%; filter:blur(160px); pointer-events:none; z-index:0; opacity:0.7; }
.a1 { width:900px;height:900px; background:radial-gradient(circle, rgba(231,76,60,0.14), transparent 55%); top:-30%; left:-18%; animation:amb1 20s ease-in-out infinite; }
.a2 { width:700px;height:700px; background:radial-gradient(circle, rgba(245,158,11,0.10), transparent 55%); bottom:-20%; right:-15%; animation:amb2 24s ease-in-out 3s infinite; }
.a3 { width:500px;height:500px; background:radial-gradient(circle, rgba(139,92,246,0.08), transparent 55%); top:45%; left:55%; animation:amb1 18s ease-in-out 7s infinite; }
@keyframes amb1 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(35px,-15px) scale(1.08)} }
@keyframes amb2 { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(-25px,15px) scale(1.06)} }

.ring { position:fixed; border-radius:50%; border:2px solid; pointer-events:none; z-index:0; opacity:0.1; animation:rFloat 16s ease-in-out infinite; }
.r1 { width:320px;height:320px; border-color:rgba(231,76,60,0.5); top:15%; left:5%; }
.r2 { width:220px;height:220px; border-color:rgba(245,158,11,0.4); bottom:20%; right:8%; animation-delay:6s; }
@keyframes rFloat { 0%,100%{transform:translate(0,0) rotate(0deg)} 50%{transform:translate(15px,-8px) rotate(18deg)} }

.dots { position:fixed; inset:0; z-index:1; pointer-events:none; opacity:0.4;
  background-image:radial-gradient(1.5px 1.5px at 15% 25%, rgba(231,76,60,0.4), transparent),radial-gradient(1px 1px at 40% 60%, rgba(245,158,11,0.35), transparent),radial-gradient(1.5px 1.5px at 65% 20%, rgba(231,76,60,0.35), transparent),radial-gradient(1px 1px at 80% 65%, rgba(245,158,11,0.32), transparent),radial-gradient(1.5px 1.5px at 88% 35%, rgba(139,92,246,0.35), transparent),radial-gradient(1px 1px at 22% 80%, rgba(231,76,60,0.3), transparent),radial-gradient(1.5px 1.5px at 50% 88%, rgba(245,158,11,0.3), transparent),radial-gradient(1px 1px at 95% 12%, rgba(231,76,60,0.32), transparent);
  background-size:200px 200px; animation:dots 28s linear infinite; }
@keyframes dots { 0%{background-position:0 0} 100%{background-position:200px 200px} }

/* Hero */
.hero { position:relative; z-index:2; width:min(100%,820px); margin:0 auto; padding:100px 24px 64px; text-align:center; }
.hero-visual { position:relative; display:block; width:180px; height:180px; margin:0 auto 40px; }
.hv-glow { position:absolute; inset:-25px; border-radius:50%; background:radial-gradient(circle, rgba(231,76,60,0.12), transparent 60%); animation:hvPulse 6s ease-in-out infinite; }
@keyframes hvPulse { 0%,100%{transform:scale(1);opacity:0.5} 50%{transform:scale(1.25);opacity:0.2} }
.hv-ring { position:absolute; inset:-35px; border-radius:50%; border:2px dashed rgba(231,76,60,0.1); animation:hvSpin 25s linear infinite; }
@keyframes hvSpin { 0%{transform:rotate(0deg)} 100%{transform:rotate(360deg)} }
.hero-visual svg { width:180px; height:180px; position:relative; z-index:1; filter:drop-shadow(0 16px 48px rgba(231,76,60,0.22)); }

.chip { display:inline-block; padding:5px 16px; border-radius:18px; font-size:11px; font-weight:600; letter-spacing:0.05em; color:#e74c3c; background:rgba(231,76,60,0.04); border:1px solid rgba(231,76,60,0.08); margin-bottom:28px; }
.hero h1 { font-size:48px; font-weight:800; margin:0 0 16px; letter-spacing:-0.04em; line-height:1.1; text-wrap:balance;
  background:linear-gradient(135deg, #1a1744 25%, #e74c3c 60%, #f59e0b 100%); -webkit-background-clip:text; background-clip:text; -webkit-text-fill-color:transparent; }
.hero>p { font-size:17px; color:#6b6990; margin:0 auto 52px; max-width:520px; line-height:1.6; }

.kpi { display:flex; gap:18px; justify-content:center; flex-wrap:wrap; }
.kp { padding:20px 24px; border-radius:18px; background:#fff; box-shadow:0 2px 4px rgba(231,76,60,0.03),0 8px 24px rgba(231,76,60,0.05); border:1px solid rgba(231,76,60,0.03); min-width:140px; transition:all 0.4s; position:relative; overflow:hidden; }
.kp::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; }
.kp:nth-child(1)::before { background:linear-gradient(90deg, #e74c3c, #f59e0b); }
.kp:nth-child(2)::before { background:linear-gradient(90deg, #f59e0b, #e74c3c); }
.kp:nth-child(3)::before { background:linear-gradient(90deg, #8b5cf6, #e74c3c); }
.kp:nth-child(4)::before { background:linear-gradient(90deg, #e74c3c, #8b5cf6); }
.kp:hover { transform:translateY(-4px) !important; box-shadow:0 4px 12px rgba(231,76,60,0.06),0 14px 40px rgba(231,76,60,0.08); }
.kp em { font-size:38px; font-weight:800; font-style:normal; color:#e74c3c; display:block; line-height:1; }
.kp em span { font-size:15px; font-weight:600; color:#8b89a8; }
.kp label { font-size:11px; color:#9b99b8; display:block; margin-top:5px; letter-spacing:0.02em; }

/* Main */
.main { position:relative; z-index:2; width:min(100%,1000px); margin:0 auto; padding:0 24px 100px; }
.sec-head { display:flex; align-items:center; gap:14px; margin:60px 0 22px; }
.sh-tag { padding:4px 12px; border-radius:8px; font-size:10px; font-weight:700; letter-spacing:0.15em; color:#e74c3c; background:rgba(231,76,60,0.05); border:1px solid rgba(231,76,60,0.06); text-transform:uppercase; }
.sec-head h2 { font-size:24px; font-weight:800; color:#1a1744; margin:0; }

/* Intro */
.intro-card { position:relative; padding:26px 30px; border-radius:16px; background:#fff; border:1px solid rgba(231,76,60,0.03); box-shadow:0 2px 6px rgba(231,76,60,0.02); transition:all 0.4s; }
.intro-card:hover { border-color:rgba(231,76,60,0.08); box-shadow:0 4px 20px rgba(231,76,60,0.04); }
.ic-line { position:absolute; left:0; top:18px; bottom:18px; width:3px; border-radius:2px; background:linear-gradient(180deg, #e74c3c, #f59e0b); }
.intro-card p { font-size:15px; line-height:1.9; color:#5b5888; margin:0 0 0 16px; }
.intro-card strong { color:#e74c3c; font-weight:700; }

/* Feature cards */
.fgrid { display:grid; grid-template-columns:repeat(2, 1fr); gap:18px; }
.fcard { position:relative; border-radius:18px; background:#fff; overflow:hidden; border:1px solid rgba(231,76,60,0.02); box-shadow:0 2px 4px rgba(231,76,60,0.02),0 6px 20px rgba(231,76,60,0.04); padding:22px 24px 22px 54px; transition:all 0.5s ease; }
.fcard:hover { border-color:rgba(231,76,60,0.1); box-shadow:0 4px 12px rgba(231,76,60,0.05),0 16px 48px rgba(231,76,60,0.06); transform:translateY(-4px) !important; }
.fc-top { position:absolute; top:0; left:0; right:0; height:4px; }
.fcard:nth-child(1) .fc-top { background:linear-gradient(90deg, #e74c3c, #f59e0b); }
.fcard:nth-child(2) .fc-top { background:linear-gradient(90deg, #f59e0b, #f7b731); }
.fcard:nth-child(3) .fc-top { background:linear-gradient(90deg, #8b5cf6, #e74c3c); }
.fcard:nth-child(4) .fc-top { background:linear-gradient(90deg, #e74c3c, #8b5cf6); }
.fc-icon { position:absolute; left:14px; top:20px; width:26px; height:26px; border-radius:7px; display:flex; align-items:center; justify-content:center; color:#fff; }
.fc-icon :deep(svg) { width:14px; height:14px; }
.fcard:nth-child(1) .fc-icon { background:linear-gradient(135deg, #e74c3c, #f59e0b); }
.fcard:nth-child(2) .fc-icon { background:linear-gradient(135deg, #f59e0b, #f7b731); }
.fcard:nth-child(3) .fc-icon { background:linear-gradient(135deg, #8b5cf6, #e74c3c); }
.fcard:nth-child(4) .fc-icon { background:linear-gradient(135deg, #e74c3c, #8b5cf6); }
.fc-body h4 { font-size:15px; font-weight:700; color:#1a1744; margin:0; }
.fc-body > p { font-size:13px; color:#6b6990; line-height:1.5; margin:4px 0 0; }

/* Scene cards */
.scard { position:relative; padding:22px 24px 22px 54px; border-radius:14px; background:#fff; border:1px solid rgba(231,76,60,0.02); box-shadow:0 2px 4px rgba(231,76,60,0.02),0 6px 20px rgba(231,76,60,0.04); transition:all 0.4s; }
.scard:hover { border-color:rgba(231,76,60,0.08); box-shadow:0 4px 16px rgba(231,76,60,0.05); }
.sn { position:absolute; left:14px; top:20px; width:26px; height:26px; border-radius:7px; background:linear-gradient(135deg, #e74c3c, #f59e0b); color:#fff; font-size:12px; font-weight:700; display:flex; align-items:center; justify-content:center; }
.scard:nth-child(2) .sn { background:linear-gradient(135deg, #f59e0b, #f7b731); }
.scard:nth-child(3) .sn { background:linear-gradient(135deg, #8b5cf6, #e74c3c); }
.scard:nth-child(4) .sn { background:linear-gradient(135deg, #e74c3c, #8b5cf6); }
.scard h5 { font-size:15px; font-weight:700; color:#1a1744; margin:0 0 4px; }
.scard p { font-size:13px; color:#6b6990; line-height:1.5; margin:0; }

/* Apply */
.apply { position:relative; margin-top:68px; padding:48px 48px; border-radius:22px; overflow:hidden; background:linear-gradient(135deg, #2d0a0a, #1c0808, #1a0a0a); color:#fff; }
.ag { position:absolute; border-radius:50%; pointer-events:none; animation:agFloat 8s ease-in-out infinite; }
.a1 { width:480px;height:480px; background:radial-gradient(circle, rgba(231,76,60,0.3), transparent 60%); top:-32%; right:-16%; }
.a2 { width:350px;height:350px; background:radial-gradient(circle, rgba(245,158,11,0.2), transparent 60%); bottom:-12%; left:-10%; animation-delay:3s; }
.a3 { width:240px;height:240px; background:radial-gradient(circle, rgba(139,92,246,0.14), transparent 60%); top:40%; left:55%; animation-delay:5s; }
@keyframes agFloat { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(15px,-10px) scale(1.1)} }
.apply h2 { font-size:28px; font-weight:800; margin:0 0 8px; position:relative; }
.apply>p { color:rgba(255,255,255,0.35); font-size:13px; margin:0 0 32px; position:relative; }
.form-row { display:grid; grid-template-columns:1fr 1fr; gap:0 20px; position:relative; }
.btns { display:flex; align-items:center; gap:14px; padding-top:8px; position:relative; }
.btn-p { padding:14px 40px !important; font-size:15px !important; font-weight:700 !important; border-radius:30px !important; background:linear-gradient(135deg, #e74c3c, #f59e0b) !important; border:none !important; height:auto !important; }
.btn-p:hover { box-shadow:0 0 36px rgba(231,76,60,0.5) !important; }
.hint { color:rgba(255,255,255,0.3); font-size:13px; }

.apply :deep(.el-form-item__label) { color:rgba(255,255,255,0.45) !important; font-size:12px; }
.apply :deep(.el-input__inner), .apply :deep(.el-textarea__inner) { background:rgba(255,255,255,0.05) !important; border-color:rgba(255,255,255,0.08) !important; color:#fff !important; border-radius:10px !important; }
.apply :deep(.el-input__inner::placeholder), .apply :deep(.el-textarea__inner::placeholder) { color:rgba(255,255,255,0.18); }

.foot { position:relative; z-index:2; margin-top:60px; background:#0f0c22; overflow:hidden; }
.foot-glow { position:absolute; top:0; left:50%; transform:translateX(-50%); width:600px; height:300px; border-radius:50%; background:radial-gradient(ellipse at center, rgba(231,76,60,0.12), transparent 70%); pointer-events:none; }
.foot-top { max-width:1100px; margin:0 auto; padding:44px 24px 32px; position:relative; text-align:center; }
.foot-logo { height:34px; width:auto; margin:0 auto 10px; object-fit:contain; }
.foot-desc { font-family:'Alibaba', sans-serif; font-size:17px; font-weight:700; color:rgba(255,255,255,0.6); letter-spacing:0.08em; margin:0 0 18px; }
.foot-links { display:flex; justify-content:center; flex-wrap:wrap; gap:8px 26px; }
.foot-links h5 { display:none; }
.foot-links a { font-size:13.5px; font-weight:500; color:rgba(255,255,255,0.7); text-decoration:none; padding:4px 0; position:relative; transition:color 0.25s, text-shadow 0.25s; }
.foot-links a::after { content:''; position:absolute; left:50%; bottom:0; width:0; height:1.5px; border-radius:1px; background:linear-gradient(90deg, transparent, #fff, transparent); transform:translateX(-50%); transition:width 0.35s cubic-bezier(0.25,0.8,0.25,1.4); }
.foot-links a:hover { color:#fff; text-shadow:0 0 12px rgba(255,255,255,0.5); }
.foot-links a:hover::after { width:100%; }
.foot-bar { margin-top:26px; padding:16px 24px; border-top:1px solid rgba(255,255,255,0.08); display:flex; align-items:center; justify-content:center; gap:14px; font-size:11px; font-weight:400; letter-spacing:0.04em; color:rgba(255,255,255,0.35); position:relative; }
.foot-bar a { color:rgba(255,255,255,0.55); text-decoration:none; transition:color 0.2s; }
.foot-bar a:hover { color:#f59e0b; }

/* ===== MOBILE ===== */
@media(max-width:768px){
  .page { padding-top:72px; overflow-x:hidden; }
  .amb,.ring,.bg-grid,.dots { display:none; }
  .nav-bar { top:8px; width:calc(100% - 16px); height:50px; padding:0 12px; border-radius:18px; flex-wrap:nowrap; overflow:hidden; backdrop-filter:blur(12px) saturate(190%); -webkit-backdrop-filter:blur(12px) saturate(190%); }
  .nav-logo { height:22px; margin-right:12px; margin-left:4px; flex-shrink:0; }
  .nav-f, .nav-s { display:none; }
  .nav-back { font-size:10px; padding:5px 10px; margin-left:auto; flex-shrink:0; white-space:nowrap; }
  .hero { width:100%; max-width:100%; padding:36px 16px 28px; box-sizing:border-box; }
  .hero h1 { font-size:26px; word-break:break-word; }
  .hero>p { font-size:14px; margin-bottom:28px; padding:0 4px; }
  .hero-visual { width:100px; height:100px; margin-bottom:24px; }
  .hero-visual svg { width:100px; height:100px; }
  .hv-glow { inset:-15px; }
  .hv-ring { inset:-25px; }
  .kpi { gap:6px; padding:0; }
  .kp { flex:1 1 calc(50% - 6px); min-width:0; padding:12px 8px; border-radius:14px; }
  .kp em { font-size:24px; }
  .kp em span { font-size:11px; }
  .kp label { font-size:10px; }
  .main { width:100%; max-width:100%; padding:0 12px 50px; box-sizing:border-box; }
  .sec-head { margin:36px 0 14px; }
  .fgrid { grid-template-columns:1fr; gap:10px; }
  .fcard { padding:14px 14px 14px 40px; }
  .fc-icon { left:8px; top:14px; width:22px;height:22px; border-radius:6px; }
  .fc-icon :deep(svg) { width:12px;height:12px; }
  .fc-body h4 { font-size:14px; }
  .fc-body > p { font-size:12px; }
  .scard { padding:14px 14px 14px 40px; }
  .scard .sn { left:8px; top:14px; width:22px; height:22px; font-size:10px; }
  .scard h5 { font-size:14px; }
  .scard p { font-size:12px; }
  .intro-card { padding:18px 16px; }
  .intro-card p { font-size:13px; margin-left:10px; }
  .apply { padding:20px 16px; margin-top:36px; border-radius:16px; }
  .apply h2 { font-size:20px; }
  .apply>p { font-size:12px; margin-bottom:20px; }
  .form-row { grid-template-columns:1fr; gap:0; }
  .btns { flex-direction:column; align-items:stretch; gap:10px; }
  .btn-p { width:100%; text-align:center; }
  .hint { font-size:11px; text-align:center; }
  .sh-tag { font-size:9px; padding:3px 10px; }
  .foot { margin-top:40px; }
  .foot-top { padding:32px 16px 24px; }
  .foot-links { gap:6px 18px; }
  .foot-links a { font-size:12px; }
  .foot-bar { flex-wrap:wrap; gap:10px; padding:14px 16px; font-size:10px; letter-spacing:0.04em; }
  .sec-head h2 { font-size:20px; }
}

/* iPhone 14 Pro Max / large phones */
@media(max-width:430px){
  .page { padding-top:64px; }
  .nav-bar { top:6px; width:calc(100% - 4px); height:40px; padding:0 10px; border-radius:14px; }
  .nav-logo { height:20px; margin-right:10px; }
  .nav-back { font-size:9px; padding:4px 8px; }
  .hero { padding:28px 14px 24px; }
  .hero h1 { font-size:22px; }
  .hero>p { font-size:13px; margin-bottom:24px; }
  .hero-visual { width:80px; height:80px; margin-bottom:20px; }
  .hero-visual svg { width:80px; height:80px; }
  .kpi { gap:4px; }
  .kp { padding:10px 6px; border-radius:12px; }
  .kp em { font-size:20px; }
  .kp label { font-size:9px; }
  .main { padding:0 10px 40px; }
  .sec-head { margin:28px 0 12px; }
  .sec-head h2 { font-size:18px; }
  .fcard { padding:12px 12px 12px 36px; border-radius:14px; }
  .fc-icon { left:6px; top:12px; width:20px;height:20px; border-radius:5px; }
  .fc-icon :deep(svg) { width:11px;height:11px; }
  .fc-body h4 { font-size:13px; }
  .fc-body > p { font-size:11px; }
  .scard { padding:12px 12px 12px 36px; border-radius:12px; }
  .scard .sn { left:6px; top:12px; width:20px; height:20px; font-size:9px; }
  .scard h5 { font-size:13px; }
  .scard p { font-size:11px; }
  .intro-card { padding:14px 12px; border-radius:14px; }
  .intro-card p { font-size:12px; margin-left:8px; }
  .apply { padding:16px 14px; margin-top:28px; border-radius:14px; }
  .apply h2 { font-size:18px; }
  .apply>p { font-size:11px; margin-bottom:16px; }
  .btn-p { font-size:13px !important; padding:12px 24px !important; }
  .hint { font-size:11px; }
  .foot-top { padding:24px 12px 16px; }
  .foot-logo { height:28px; }
  .foot-desc { font-size:11px; margin-bottom:16px; }
  .foot-links { gap:4px 12px; }
  .foot-links a { font-size:11px; }
  .foot-bar { gap:8px; font-size:9px; letter-spacing:0.03em; }
}

@media(max-width:768px){ .fgrid,.form-row{grid-template-columns:1fr} .hero h1{font-size:30px} .kpi{gap:10px} .kp{min-width:120px;padding:14px 16px} .kp em{font-size:30px} .apply{padding:32px 24px} }
@media (prefers-reduced-motion: reduce) { .amb,.ring,.dots,.ag,.hv-glow,.hv-ring,[class*="animate"] { animation:none !important; transition:none !important; } }
</style>
